import React from "react";
import "../../Styles/certified/anubavam.css";

export default function Finzly() {
  return (
    <>
      <div className="anubavam-certified-details-section">
        <div className="anubavam-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="anubavam-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="anubavam-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="anubavam-certified-badge"
            />
            <div className="anubavam-certified-company-names">
              <a href="https://www.anubavam.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/anubavam/anubavam.png"
                alt="Walkzero Logo"
                className="anubavam-certified-company-logo"
              />
            </a>
              <h1 className="anubavam-certified-full-name">
            Anubavam Technologies Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="anubavam-certified-details-right">
            <img
              src="/assets/anubavam/anu_1.jpg"
              alt="Finzly Office"
              className="anubavam-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="anubavam-certified-description">
          <h2>
            Why  Anubavam Technologies Private Limited is an Outstanding Workplaces
          </h2>
          <p>
           For close to twenty years, Anubavam Technologies has built software for organizations operating under significant complexity, working as a genuinely global team across offices in the USA, India, Malaysia, and the UAE. Founded in 2006, the company has grown across time zones and cultures as one organization rather than a set of separate regional outposts.


          </p>
          <p>Its culture rests on five values, known internally as ECCTA: empathetic, committed, collaborative, trustworthy, and accountable. The name Anubavam means to create an exceptional experience, and the company holds that the experience begins internally, in how colleagues treat one another. Empathy shows up as patience, mutual support, and recognising the pressure each person carries. Collaboration crosses every department and border, on the principle that the goal is not to be the smartest person in the room, but to make the whole room smarter. Continuous learning, for both the individual and the organization, is treated as a standing commitment.</p>
          
        </div>
        {/* Info Cards Section */}
        <div className="anubavam-certified-info-cards">
          <div className="anubavam-certified-info-card">
            <div className="anubavam-certified-info-title">COMPANY SIZE</div>
            <div className="anubavam-certified-info-value">150 Employees</div>
          </div>
          <div className="anubavam-certified-info-card">
            <div className="anubavam-certified-info-title">INDUSTRY</div>
            <div className="anubavam-certified-info-value">Information Technology 


</div>
          </div>
          <div className="anubavam-certified-info-card">
            <div className="anubavam-certified-info-title">CONNECT</div>
            <div className="anubavam-certified-info-icons">
              <span className="anubavam-certified-icon-round">
                <a href="https://www.anubavam.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="anubavam-certified-icon-round">
                <a href="https://www.linkedin.com/company/anubavam/?originalSubdomain=in" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="anubavam-certified-icon-round">
                <a href="https://www.facebook.com/anubavam/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="anubavam-certified-info-card">
            <div className="anubavam-certified-info-title">LOCATION (HQ)</div>
            <div className="anubavam-certified-info-value">Chennai </div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="anubavam-certified-recognition-section">
          <h2 className="anubavam-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="anubavam-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="anubavam-certified-recognition-image"
            />
          </div>
          <div className="anubavam-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="anubavam-certified-life-section">
          <h2 className="anubavam-certified-life-title">
            Life at Anubavam Technologies Private Limited
          </h2>
          <div className="anubavam-certified-life-gallery">
            <div className="anubavam-certified-life-col">
              <img src="/assets/anubavam/anu_1.jpg" alt="Office 1" className="anubavam-certified-life-img" />
              <img src="/assets/anubavam/anu_2.jpg" alt="Team 1" className="anubavam-certified-life-img" />
            </div>
            <div className="icom-certified-life-col anubavam-certified-life-center">
              <img src="/assets/anubavam/anu_3.jpg" alt="Main Office" className="anubavam-certified-life-img anubavam-certified-life-img-large" />
            </div>
            <div className="anubavam-certified-life-col">
              <img src="/assets/anubavam/anu_4.jpg" alt="Office 2" className="anubavam-certified-life-img" />
              <img src="/assets/anubavam/anu_5.jpg" alt="Team 2" className="anubavam-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
